export default {
	AREA: "area"
};


// WEBPACK FOOTER //
// ./src/components/partials/areas/ItemTypes.js